import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { ModelCaso } from 'src/app/model/pld/detallecaso.model';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { AlertasService } from 'src/services/pld/alertas.service';
import { registerLocaleData } from '@angular/common';
import localeMX from '@angular/common/locales/es-MX';

@Component({
  selector: 'app-addcase-general-data',
  templateUrl: './addcase-general-data.component.html',
  styleUrls: ['./addcase-general-data.component.css']
})
export class AddcaseGeneralDataComponent implements OnInit, AfterViewChecked {

  alertas = [];
  buscando = false;
  montoTotal = 0;

  constructor(
    public alertaService: AlertasService,
    private catalogoService: CatalogosService
  ) { }

  ngOnInit() {
    registerLocaleData(localeMX);
    this.alertas = this.catalogoService.getAlerta();
    this.alertaService.caso.Monto = 0;
  }

  ngAfterViewChecked(): void {
    if (this.alertaService.persona === undefined) return;
    if (this.alertaService.transaccionesRelacionar === undefined) return;
    if (this.alertaService.transaccionesRelacionar.length === 0) return;
    if (this.buscando) return;

    this.buscando = true;
    this.alertaService.caso.Nombre = `${this.alertaService.persona.nombre} ${this.alertaService.persona.sNombre} ${this.alertaService.persona.apellidoPaterno} ${this.alertaService.persona.apellidoMaterno}`;
    this.alertaService.caso.ClaveCia = this.alertaService.persona.claveCia;
    this.alertaService.caso.PersonaId = this.alertaService.persona.personaId;
    this.alertaService.caso.Monto = this.getMonto();
  }

  getMonto(): number {
    let total = 0.0;
    if (this.alertaService.transaccionesRelacionar === undefined) return total;
    if (this.alertaService.transaccionesRelacionar.length === 0) return total;
    this.alertaService.transaccionesRelacionar.forEach(element => {
      total += Number(element.tMontoTotal.replace('$', '').replace(',', ''));
    });
    return total;
  }

  esRelevante(): boolean {
    return Number(this.alertaService.caso.AlertaId) === 59 || Number(this.alertaService.caso.AlertaId) === 60;
  }

}
